// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BlockDesc_wrapper__R4Umf","test":"BlockDesc_test__2aFaq","desc":"BlockDesc_desc__2M7Gc"};